import type { InjectedRouter } from 'js/lib/connectToRouter';
import user from 'js/lib/user';

type authMode = 'login' | 'signup';

export default function confirmAuthenticated(router: InjectedRouter, mode: authMode = 'login') {
  if (!user.isAuthenticatedUser()) {
    const { pathname, params, query } = router.location;

    router.push({
      pathname,
      params,
      query: {
        ...query,
        authMode: mode,
      },
    });
  }
}
